export const tripTableAdditionalColumnsKeys = {
    childCount: 'childCount',
} as const;
